module.exports = __webpack_public_path__ + "static/img/5.c12dbca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/5.png
// module id = zYNX
// module chunks = 1